// Only used to SKIP reauth, so deliberately far shorter than Firebase's ~5-min
// window: a wrong "fresh" fails the delete; a wrong "stale" costs one confirmation.
const RECENT_LOGIN_WINDOW_MS = 2 * 60 * 1000;

export const isRecentLogin = (
  lastSignInTime: string | undefined,
  now: Date,
): boolean => {
  if (!lastSignInTime) {
    return false;
  }

  const signedInAt = new Date(lastSignInTime).getTime();
  if (Number.isNaN(signedInAt)) {
    return false;
  }

  const age = now.getTime() - signedInAt;
  return age >= 0 && age < RECENT_LOGIN_WINDOW_MS;
};
